import { FunctionComponent } from "react";
import { Tile } from "@Types/pagify";
import "./style.scss";
import { HomeHeroItem } from "./HomeHeroItem";

export const HomeHero: FunctionComponent<{
  largeHeroImageTiles: Tile[];
  smallHeroImageTiles: Tile[];
}> = ({ largeHeroImageTiles, smallHeroImageTiles }) => {
  return (
    <div className="HomeHero">
      <HomeHeroItem tiles={largeHeroImageTiles} type="large" />
      <HomeHeroItem tiles={smallHeroImageTiles} type="small" />
    </div>
  );
};
